/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/header_panel.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { headerPanelModule } from "../../../grids/grid_core/header_panel/m_header_panel";
import gridCore from "../m_core";
export const HeaderPanel = headerPanelModule.views.headerPanel;
gridCore.registerModule("headerPanel", headerPanelModule);